import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getVideosReport } from '../../services/Reports';

function useGetVideosReport(fleetId: string, query: string): UseQueryResult<any> {
  return useQuery(
    ['report-videos', fleetId, query],
    async (): Promise<any> => getVideosReport(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: false,
      refetchInterval: false,
    },
  );
}

export default useGetVideosReport;
